var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'menu-tip-wrap':true}},[_c('div',{staticClass:"triangle-bg",style:(_vm.triangleStyle)}),_c('div',{staticClass:"tip-msg",style:(_vm.msgStyle)},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }